import * as React from 'react';

import {ModalHeaderBreadcrumbs} from '../typography/modal-header-breadcrumbs';

type Props = {
    breadcrumbText: string;
    onCloseCustomizeModal: () => void;
};

export function CustomizeFieldsHeader(props: Props) {
    return (
        <ModalHeaderBreadcrumbs
            breadcrumbs={[
                {text: props.breadcrumbText, onClick: props.onCloseCustomizeModal},
                {text: 'Customize fields'},
            ]}
        />
    );
}
